





// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import { useLoader } from '../../../../context/LoaderProvider.jsx';
// import {
//     getPartnerDetails, getAllPartners, updatePartnerDetails, getAllDeliveryPartners,
//     verifyPartnerField, rejectPartnerField,
//     approvePartner, rejectPartnerApproval
// } from "../../../Servicefile/clientManagementService.jsx";
// // Delivery Partner specific field configuration
// const getDefaultDeliveryPartnerRows = () => [
//     { key: "Full Name", value: "", isUpload: false },
//     { key: "Phone Number", value: "", isUpload: false },
//     { key: "Email", value: "", isUpload: false },
//     { key: "Profile Picture", value: null, isUpload: false },
//     { key: "AADHAR Number", value: "", isUpload: false },
//     { key: "PAN Number", value: "", isUpload: false },
//     { key: "License Number", value: "", isUpload: false },
//     { key: "Vehicle Types", value: [], isUpload: false },
//     { key: "Vehicles", value: [], isUpload: false },
//     { key: "Petrolium Types", value: [], isUpload: false },
//     { key: "RC Number", value: "", isUpload: false },
//     { key: "Insurance Number", value: "", isUpload: false },
//     {
//         key: "Bank Details", value: {
//             bankName: "",
//             accountNumber: "",
//             accountHolderName: "",
//             ifscCode: "",
//             branchName: "",
//             upiId: ""
//         }, isUpload: false
//     },
//     {
//         key: "Current Address", value: {
//             address: "",
//             city: "",
//             state: "",
//             pinCode: "",
//             country: "",
//             houseNo: "",
//             street: ""
//         }, isUpload: false
//     },
//     {
//         key: "Permanent Address", value: {
//             permanentAddress: "",
//             permanentCity: "",
//             permanentState: "",
//             permanentPinCode: "",
//             permanentCountry: "",
//             permanentHouseNo: "",
//             permanentStreet: ""
//         }, isUpload: false
//     }
// ];

// // Vehicle Types options
// const vehicleTypeOptions = [
//     "BIKE",
//     "PASSENGER_AUTO",
//     "CAR",
//     "MINI_TRUCK",
//     "TRUCK"
// ];

// // Vehicles options
// const vehiclesOptions = [
//     "TwoWheeler",
//     "ThreeWheeler",
//     "FourWheeler",
//     "HeavyVehicle"
// ];

// // Petroleum Types options
// const petroliumTypeOptions = [
//     "PETROL",
//     "DIESEL",
//     "CNG",
//     "ELECTRIC"
// ];

// // Status field mapping for delivery partners
// const STATUS_FIELD_MAP = {
//     "Full Name": "fullNameStatus",
//     "Phone Number": "phoneNumberStatus",
//     "Email": "emailStatus",
//     "Profile Picture": "profilePictureStatus",
//     "AADHAR Number": "aadharNumberStatus",
//     "PAN Number": "panNumberStatus",
//     "License Number": "licenseNumberStatus",
//     "Vehicle Types": "vehicleTypesStatus",
//     "Vehicles": "vehiclesStatus",
//     "Petrolium Types": "petroliumTypesStatus",
//     "RC Number": "rcNumberStatus",
//     "Insurance Number": "insuranceNumberStatus",
//     "Bank Details": "bankDetailsStatus",
//     "Current Address": "addressStatus",
//     "Permanent Address": "permanentAddressStatus"
// };

// // Safe value display utility
// const safeDisplay = (value) => {
//     if (value === null || value === undefined) return "N/A";
//     if (typeof value === 'string' && value.trim() === "") return "N/A";
//     if (value === "N/A" || value === "Invalid Date") return "N/A";
//     return value;
// };

// // Add this function to check if a field has valid data
// const hasValidData = (row, partnerDetails) => {
//     if (!row || !partnerDetails) return false;

//     const field = row.key;
//     const value = row.value;

//     // Check if the value exists and is not empty/"N/A"
//     if (typeof value === 'string') {
//         return value && value !== "N/A" && value.trim() !== "";
//     }

//     if (Array.isArray(value)) {
//         return value.length > 0 && value.some(item => item && item !== "N/A");
//     }

//     if (typeof value === 'object') {
//         // For objects, check if any property has valid data
//         return Object.values(value).some(val => {
//             if (val === null || val === undefined) return false;
//             if (typeof val === 'string') return val.trim() !== "" && val !== "N/A";
//             if (Array.isArray(val)) return val.length > 0;
//             return true;
//         });
//     }

//     return false;
// };

// const isFieldVerified = (rowKey, rowValue, partnerDetails) => {
//     const normalisedKey = rowKey.trim().replace(/\.$/, "");
//     const statusField = STATUS_FIELD_MAP[normalisedKey];

//     if (!statusField || !partnerDetails) return false;

//     if (partnerDetails[statusField] === true) return true;

//     if ((partnerDetails[statusField] === null || partnerDetails[statusField] === undefined) &&
//         hasValidData({ key: rowKey, value: rowValue }, partnerDetails)) {
//         return true;
//     }

//     return false;
// };

// const isFieldRejected = (rowKey, partnerDetails) => {
//     const normalisedKey = rowKey.trim().replace(/\.$/, "");
//     const statusField = STATUS_FIELD_MAP[normalisedKey];

//     if (!statusField || !partnerDetails) return false;

//     return partnerDetails[statusField] === false;
// };

// /* ---------------- component ---------------- */
// const DeliveryPartnerManagement = () => {
//     /* -------- list‑screen state -------- */
//     const [partnersData, setPartnersData] = useState([]);
//     const [statusFilter, setStatusFilter] = useState("");
//     const [vehicleFilter, setVehicleFilter] = useState("");
//     const [cityFilter, setCityFilter] = useState("");
//     const [filteredData, setFilteredData] = useState([]);
//     const { showLoader, hideLoader } = useLoader();

//     // New search filter states
//     const [searchType, setSearchType] = useState("partnerId");
//     const [searchQuery, setSearchQuery] = useState("");

//     /* -------- detail‑screen state -------- */
//     const [selectedPartner, setSelectedPartner] = useState(null);
//     const [partnerDetails, setPartnerDetails] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [rows, setRows] = useState(getDefaultDeliveryPartnerRows());
//     const [verifiedRows, setVerifiedRows] = useState([]);
//     const [rejectedRows, setRejectedRows] = useState([]);
//     const [isApproved, setIsApproved] = useState(false);
//     const [imageLoadErrors, setImageLoadErrors] = useState(new Set());

//     const fileInputRef = useRef(null);
//     const [partnerData, setPartnerData] = useState({});
//     const [rowId, setRowId] = useState(null);

//     // State for reject modal/dropdown
//     const [showRejectDropdown, setShowRejectDropdown] = useState(false);
//     const [rejectionDescription, setRejectionDescription] = useState("");

//     // Add loading states for approve and reject
//     const [isApproving, setIsApproving] = useState(false);
//     const [isRejecting, setIsRejecting] = useState(false);

//     // Add refresh key for forcing updates
//     const [refreshKey, setRefreshKey] = useState(0);

//     const getCurrentPartnerId = () => {
//         return (
//             selectedPartner?.id ||
//             selectedPartner?.partnerId ||
//             partnerDetails?.id ||
//             null
//         );
//     };

//     const partnerId = getCurrentPartnerId();

//     const handleImageError = (imageUrl, fieldName, index) => {
//         const errorKey = `${fieldName}-${index}`;
//         setImageLoadErrors(prev => new Set([...prev, errorKey]));
//     };

//     const handleImageLoad = (imageUrl, fieldName, index) => {
//         const errorKey = `${fieldName}-${index}`;
//         setImageLoadErrors(prev => {
//             const newSet = new Set(prev);
//             newSet.delete(errorKey);
//             return newSet;
//         });
//     };

//     const isImageFailed = (fieldName, index) => {
//         return imageLoadErrors.has(`${fieldName}-${index}`);
//     };

//     const fetchPartnerDetails = async (partnerId) => {
//         if (!partnerId) return;

//         setLoading(true);

//         const token = localStorage.getItem("authToken");

//         try {

//             console.log(`🔍 FETCHING PARTNER DETAILS FOR ID: ${partnerId}`);

//             // 🔥 SERVICE API
//             const data = await getPartnerDetails(partnerId, token);

//             console.log("✅ API RESPONSE RECEIVED:", data);

//             setPartnerDetails(data);

//         } catch (err) {

//             console.error("❌ get-partner-details error:", err);

//             // FALLBACK DATA
//             const listPartner = partnersData.find(
//                 p => p.id === partnerId || p.partnerId === partnerId
//             );

//             if (listPartner) {

//                 console.log("⚠️ Falling back to list data:", listPartner);

//                 setPartnerDetails(listPartner);
//             }

//         } finally {

//             setLoading(false);
//         }
//     };

//     // Function to refresh all data
//     const refreshAllData = async () => {
//         const token = localStorage.getItem("authToken");

//         if (!token) {
//             console.error("No auth token found");
//             return;
//         }

//         showLoader();

//         try {

//             // 🔥 SERVICE API
//             const data = await getAllPartners(token);

//             console.log("📊 Refreshed partners data:", data);

//             setPartnersData(data);

//             if (selectedPartner) {

//                 const currentPartnerId =
//                     selectedPartner?.id ||
//                     selectedPartner?.partnerId;

//                 if (currentPartnerId) {
//                     await fetchPartnerDetails(currentPartnerId);
//                 }
//             }

//         } catch (err) {

//             console.error("Refresh data error:", err);

//         } finally {

//             hideLoader();
//         }
//     };
//     // Save row using the update API endpoint
//     const handleSaveRow = async (rowIndex) => {

//         const token =
//             localStorage.getItem("authToken") ||
//             localStorage.getItem("token");

//         if (!token) {
//             alert("No authentication token found");
//             return;
//         }

//         try {

//             const partnerId = getCurrentPartnerId();

//             if (!partnerId) {
//                 console.error("Partner ID not found");
//                 return;
//             }

//             const row = rows[rowIndex];

//             console.log("Editing row:", row);

//             const formData = new FormData();

//             const partnerData = {};

//             const fieldMapping = {
//                 "Full Name": "fullName",
//                 "Phone Number": "phoneNumber",
//                 "Email": "email",
//                 "AADHAR Number": "aadharNumber",
//                 "PAN Number": "panNumber",
//                 "License Number": "licenseNumber",
//                 "Vehicle Types": "vehicleTypes",
//                 "Vehicles": "vehicles",
//                 "Petrolium Types": "petroliumTypes",
//                 "RC Number": "rcNumber",
//                 "Insurance Number": "insuranceNumber",
//             };

//             const backendFieldName =
//                 fieldMapping[row.key];

//             if (
//                 backendFieldName &&
//                 row.value &&
//                 row.value !== "N/A"
//             ) {

//                 if (Array.isArray(row.value)) {
//                     partnerData[backendFieldName] = row.value;

//                 } else if (typeof row.value === "string") {
//                     partnerData[backendFieldName] = row.value;
//                 }
//             }

//             // ADDRESS
//             if (
//                 row.key === "Current Address" &&
//                 typeof row.value === "object"
//             ) {

//                 Object.keys(row.value).forEach(key => {
//                     if (row.value[key] !== "N/A") {
//                         partnerData[key] = row.value[key];
//                     }
//                 });
//             }

//             // PERMANENT ADDRESS
//             if (
//                 row.key === "Permanent Address" &&
//                 typeof row.value === "object"
//             ) {

//                 Object.keys(row.value).forEach(key => {
//                     if (row.value[key] !== "N/A") {
//                         partnerData[key] = row.value[key];
//                     }
//                 });
//             }

//             // BANK DETAILS
//             if (
//                 row.key === "Bank Details" &&
//                 typeof row.value === "object"
//             ) {

//                 Object.keys(row.value).forEach(key => {
//                     if (row.value[key] !== "N/A") {
//                         partnerData[key] = row.value[key];
//                     }
//                 });
//             }

//             // JSON DATA
//             formData.append(
//                 "partnerData",
//                 new Blob(
//                     [JSON.stringify(partnerData)],
//                     { type: "application/json" }
//                 )
//             );

//             // IMAGES
//             if (row.images && row.images.length > 0) {

//                 row.images.forEach((img, idx) => {

//                     if (img.file) {

//                         const imageFieldName =
//                             getImageFieldName(row.key, idx);

//                         formData.append(
//                             imageFieldName,
//                             img.file
//                         );
//                     }
//                 });
//             }

//             // 🔥 SERVICE API
//             await updatePartnerDetails(
//                 partnerId,
//                 formData,
//                 token
//             );

//             alert("Data updated successfully!");

//             setRows(prev =>
//                 prev.map((r, idx) =>
//                     idx === rowIndex
//                         ? { ...r, isEditing: false }
//                         : r
//                 )
//             );

//             fetchPartnerDetails(partnerId);

//         } catch (err) {

//             console.error("Error updating partner:", err);

//             alert(
//                 "Error updating data: " +
//                 (err.response?.data?.message || err.message)
//             );
//         }
//     };

//     const getImageFieldName = (rowKey, imageIndex) => {
//         const fieldMap = {
//             "AADHAR Number": imageIndex === 0 ? "aadharCardFront" : "aadharCardBack",
//             "PAN Number": "panCard",
//             "License Number": imageIndex === 0 ? "licenseFront" : "licenseBack",
//             "Profile Picture": "profilePicture",
//             "RC Number": imageIndex === 0 ? "rcBookFront" : "rcBookBack",
//         };

//         return fieldMap[rowKey] || `image${imageIndex + 1}`;
//     };

//     // Search options for dropdown
//     const searchOptions = [
//         { value: "partnerId", label: "Partner ID" },
//         { value: "fullName", label: "Full Name" },
//         { value: "email", label: "Email" },
//         { value: "phoneNumber", label: "Mobile Number" },
//         { value: "city", label: "City" }
//     ];

//     // Get placeholder text based on search type
//     const getPlaceholderText = () => {
//         switch (searchType) {
//             case "partnerId": return "Search Partner ID";
//             case "fullName": return "Search Full Name";
//             case "email": return "Search Email";
//             case "phoneNumber": return "Search Mobile Number";
//             case "city": return "Search City";
//             default: return "Search...";
//         }
//     };

//     // Clear all search filters
//     const clearAllFilters = () => {
//         setSearchQuery("");
//         setStatusFilter("");
//         setVehicleFilter("");
//         setCityFilter("");
//     };

//     useEffect(() => {

//         const token =
//             localStorage.getItem("authToken");

//         if (!token) {
//             console.error("No auth token found");
//             return;
//         }

//         const fetchPartners = async () => {

//             try {

//                 showLoader();

//                 // 🔥 SERVICE API
//                 const data =
//                     await getAllDeliveryPartners(token);

//                 console.log("📊 Initial partners data:", data);

//                 setPartnersData(data);

//             } catch (err) {

//                 console.error("Partners fetch error:", err);

//             } finally {

//                 hideLoader();
//             }
//         };

//         fetchPartners();

//     }, [refreshKey]);

//     useEffect(() => {
//         let data = partnersData;

//         // Apply status filter
//         if (statusFilter) {
//             if (statusFilter === "verified") {
//                 data = data.filter((i) => i.verified === true);
//             } else if (statusFilter === "not-verified") {
//                 data = data.filter((i) => i.verified === false);
//             }
//         }

//         // Apply vehicle filter
//         if (vehicleFilter) {
//             data = data.filter((i) =>
//                 i.vehicleTypes?.includes(vehicleFilter) ||
//                 i.vehicles?.includes(vehicleFilter)
//             );
//         }

//         // Apply city filter
//         if (cityFilter) {
//             data = data.filter((i) => i.city === cityFilter);
//         }

//         // Apply search query filter
//         if (searchQuery.trim()) {
//             const query = searchQuery.toLowerCase().trim();
//             data = data.filter(partner => {
//                 // Get the field value based on searchType
//                 let fieldValue;

//                 // Handle different field names in the data
//                 if (searchType === "phoneNumber") {
//                     fieldValue = partner.phoneNumber || partner.maskedPhoneNumber;
//                 } else if (searchType === "email") {
//                     fieldValue = partner.email || partner.maskedEmail;
//                 } else {
//                     fieldValue = partner[searchType];
//                 }

//                 if (!fieldValue) return false;

//                 // Special handling for mobile number search
//                 if (searchType === "phoneNumber") {
//                     const cleanPartnerMobile = fieldValue.toString().replace(/\D/g, '');
//                     const cleanQuery = query.replace(/\D/g, '');
//                     return fieldValue.toString().toLowerCase().includes(query) ||
//                         cleanPartnerMobile.includes(cleanQuery);
//                 }

//                 // For other fields
//                 return fieldValue.toString().toLowerCase().includes(query);
//             });
//         }

//         setFilteredData(data);
//     }, [partnersData, statusFilter, vehicleFilter, cityFilter, searchType, searchQuery]);

//     useEffect(() => {
//         if (!selectedPartner) {
//             setRows(getDefaultDeliveryPartnerRows());
//             setVerifiedRows([]);
//             setRejectedRows([]);
//             setIsApproved(false);
//             setImageLoadErrors(new Set());
//             return;
//         }

//         // Use partnerDetails as primary data source
//         const dataSource = partnerDetails || selectedPartner;

//         console.log("📊 Data source for detail view:", dataSource);

//         // Check if partner is approved
//         if (dataSource.verified === true) {
//             setIsApproved(true);
//         }

//         // Image mapping for delivery partners
//         const imageMap = {
//             "AADHAR Number": [
//                 dataSource.aadharCardFront,
//                 dataSource.aadharCardBack
//             ].filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
//             "PAN Number": [dataSource.panCard]
//                 .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
//             "License Number": [
//                 dataSource.licenseFront,
//                 dataSource.licenseBack
//             ].filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
//             "Profile Picture": [dataSource.profilePicture]
//                 .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
//             "RC Number": [
//                 dataSource.rcBookFront,
//                 dataSource.rcBookBack
//             ].filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
//         };

//         // Create rows with actual data from the backend response
//         const newRows = [
//             {
//                 key: "Full Name",
//                 value: dataSource.fullName || "N/A"
//             },
//             {
//                 key: "Phone Number",
//                 value: dataSource.phoneNumber || "N/A"
//             },
//             {
//                 key: "Email",
//                 value: dataSource.email || "N/A"
//             },
//             {
//                 key: "Profile Picture",
//                 value: "Profile Picture"
//             },
//             {
//                 key: "AADHAR Number",
//                 value: dataSource.aadharNumber || "N/A"
//             },
//             {
//                 key: "PAN Number",
//                 value: dataSource.panNumber || "N/A"
//             },
//             {
//                 key: "License Number",
//                 value: dataSource.licenseNumber || "N/A"
//             },
//             {
//                 key: "Vehicle Types",
//                 value: Array.isArray(dataSource.vehicleTypes)
//                     ? dataSource.vehicleTypes
//                     : (dataSource.vehicleTypes ? [dataSource.vehicleTypes] : [])
//             },
//             {
//                 key: "Vehicles",
//                 value: Array.isArray(dataSource.vehicles)
//                     ? dataSource.vehicles
//                     : (dataSource.vehicles ? [dataSource.vehicles] : [])
//             },
//             {
//                 key: "Petrolium Types",
//                 value: Array.isArray(dataSource.petroliumTypes)
//                     ? dataSource.petroliumTypes
//                     : (dataSource.petroliumTypes ? [dataSource.petroliumTypes] : [])
//             },
//             {
//                 key: "RC Number",
//                 value: Array.isArray(dataSource.rcNumber) && dataSource.rcNumber.length > 0
//                     ? dataSource.rcNumber[0]
//                     : dataSource.rcNumber || "N/A"
//             },
//             {
//                 key: "Insurance Number",
//                 value: Array.isArray(dataSource.insuranceNumber) && dataSource.insuranceNumber.length > 0
//                     ? dataSource.insuranceNumber[0]
//                     : dataSource.insuranceNumber || "N/A"
//             },
//             {
//                 key: "Bank Details",
//                 value: {
//                     bankName: dataSource.bankName || "N/A",
//                     accountNumber: dataSource.accountNumber || "N/A",
//                     accountHolderName: dataSource.accountHolderName || "N/A",
//                     ifscCode: dataSource.ifscCode || "N/A",
//                     branchName: dataSource.branchName || "N/A",
//                     upiId: dataSource.upiId || "N/A",
//                 },
//             },
//             {
//                 key: "Current Address",
//                 value: {
//                     address: dataSource.address || "N/A",
//                     city: dataSource.city || "N/A",
//                     state: dataSource.state || "N/A",
//                     pinCode: dataSource.pinCode || "N/A",
//                     country: dataSource.country || "N/A",
//                     houseNo: dataSource.houseNo || "N/A",
//                     street: dataSource.street || "N/A",
//                 },
//             },
//             {
//                 key: "Permanent Address",
//                 value: {
//                     permanentAddress: dataSource.permanentAddress || "N/A",
//                     permanentCity: dataSource.permanentCity || "N/A",
//                     permanentState: dataSource.permanentState || "N/A",
//                     permanentPinCode: dataSource.permanentPinCode || "N/A",
//                     permanentCountry: dataSource.permanentCountry || "N/A",
//                     permanentHouseNo: dataSource.permanentHouseNo || "N/A",
//                     permanentStreet: dataSource.permanentStreet || "N/A",
//                 },
//             },
//         ];

//         const updatedRows = newRows.map((row) => ({
//             ...row,
//             images: imageMap[row.key] || [],
//         }));

//         console.log("🚨 DEBUG - Final rows to display:", updatedRows);

//         setRows(updatedRows.map((r) => ({ ...r, isEditing: false })));
//         setVerifiedRows([]);
//         setRejectedRows([]);
//         setImageLoadErrors(new Set());
//     }, [selectedPartner, partnerDetails]);

//     const handleViewClick = (partner) => {
//         console.log("👁️ VIEW CLICKED FOR PARTNER:", partner);
//         setSelectedPartner(partner);
//         const partnerId = partner?.id || partner?.partnerId;
//         console.log("🔍 FETCHING PARTNER DETAILS FOR ID:", partnerId);
//         fetchPartnerDetails(partnerId);
//     };

//     // Verify individual field using the new API various data customize useEffect((=> ))
//     const handleVerifyy = async (i) => {

//         const normalisedKey =
//             rows[i].key.trim().replace(/\.$/, "");

//         const statusField =
//             STATUS_FIELD_MAP[normalisedKey];

//         if (!statusField) {
//             console.warn("No status mapping for:", rows[i].key);
//             return;
//         }

//         const partnerId =
//             getCurrentPartnerId();

//         if (!partnerId)
//             return alert("Partner ID is missing");

//         try {

//             const updateData = {
//                 [statusField]: true
//             };

//             const formData = new FormData();

//             formData.append(
//                 "partnerData",

//                 new Blob(
//                     [JSON.stringify(updateData)],
//                     {
//                         type: "application/json"
//                     }
//                 )
//             );

//             // 🔥 SERVICE API
//             await verifyPartnerField(
//                 partnerId,
//                 formData,
//                 localStorage.getItem("authToken")
//             );

//             await fetchPartnerDetails(partnerId);

//             alert("Partner field verified successfully!");

//         } catch (err) {

//             console.error("❌ Verify error:", err);

//             alert(`Failed to verify field: ${err.message}`);
//         }
//     };

//     // Reject individual field using the new API
//     const handleReject = async (i) => {

//         const normalisedKey =
//             rows[i].key.trim().replace(/\.$/, "");

//         const statusField =
//             STATUS_FIELD_MAP[normalisedKey];

//         if (!statusField) return;

//         const partnerId =
//             getCurrentPartnerId();

//         if (!partnerId)
//             return alert("Partner ID is missing");

//         try {

//             const updateData = {
//                 [statusField]: false
//             };

//             const formData =
//                 new FormData();

//             formData.append(
//                 "partnerData",

//                 new Blob(
//                     [JSON.stringify(updateData)],
//                     {
//                         type: "application/json"
//                     }
//                 )
//             );

//             // 🔥 SERVICE API
//             await rejectPartnerField(
//                 partnerId,
//                 formData,
//                 localStorage.getItem("authToken")
//             );

//             alert("Partner field rejected successfully!");

//             fetchPartnerDetails(partnerId);

//         } catch (err) {

//             console.error("❌ Reject error:", err);

//             alert(`Failed to reject field: ${err.message}`);
//         }
//     };

//     // Approve all using the /admin/approval/{id} API endpoint
//     const handleApproveAll = async () => {

//         const partnerId =
//             getCurrentPartnerId();

//         if (!partnerId) {
//             alert("Partner ID is missing");
//             return;
//         }

//         setIsApproving(true);

//         try {

//             const token =
//                 localStorage.getItem("authToken");

//             if (!token) {
//                 alert("Authorization token missing");
//                 return;
//             }

//             console.log(
//                 `✅ Approving partner ${partnerId}...`
//             );

//             // CORRECT PAYLOAD
//             const payload = {
//                 rejectReason: "",
//                 verified: true
//             };

//             console.log(
//                 "📤 Approve Payload:",
//                 payload
//             );

//             // APPROVE API
//             const data =
//                 await approvePartner(
//                     partnerId,
//                     payload,
//                     token
//                 );

//             console.log(
//                 "✅ Approval API response:",
//                 data
//             );

//             console.log(
//                 "🟢 Full API Response:",
//                 data
//             );

//             // SUCCESS CONDITION
//             if (data) {

//                 alert(
//                     "✅ Partner approved successfully!"
//                 );

//                 // UPDATE PARTNER DETAILS
//                 setPartnerDetails(prev => ({
//                     ...prev,
//                     ...data,
//                     verified: true
//                 }));

//                 // UPDATE SELECTED PARTNER
//                 setSelectedPartner(prev => ({
//                     ...prev,
//                     ...data,
//                     verified: true
//                 }));

//                 // UPDATE TABLE DATA
//                 setPartnersData(prev =>
//                     prev.map(partner =>
//                         partner.id === partnerId ||
//                             partner.partnerId === partnerId
//                             ? {
//                                 ...partner,
//                                 ...data,
//                                 verified: true
//                             }
//                             : partner
//                     )
//                 );

//                 // LOCAL STATE
//                 setIsApproved(true);

//                 // OPTIONAL REFRESH
//                 setTimeout(() => {
//                     setRefreshKey(prev => prev + 1);
//                 }, 1000);

//             } else {

//                 alert(
//                     "⚠️ Approval failed. Empty response from backend."
//                 );
//             }

//         } catch (err) {

//             console.error(
//                 "❌ Approve partner error:",
//                 err
//             );

//             console.error(
//                 "❌ Error Response:",
//                 err.response?.data
//             );

//             const errorMessage =
//                 err.response?.data?.message ||
//                 err.response?.data?.error ||
//                 err.message;

//             alert(
//                 `Failed to approve partner: ${errorMessage}`
//             );

//         } finally {

//             setIsApproving(false);
//         }
//     };

//     // Reject all with reason using the /admin/approval/{id} API endpoint
//     const handleRejectAll = async () => {

//         if (!rejectionDescription.trim()) {
//             alert("Please enter a rejection reason");
//             return;
//         }

//         const partnerId =
//             getCurrentPartnerId();

//         if (!partnerId)
//             return alert("Partner ID is missing");

//         setIsRejecting(true);

//         try {

//             const token =
//                 localStorage.getItem("authToken");

//             if (!token)
//                 return alert("Authorization token missing");

//             const requestBody = {
//                 verified: false,
//                 rejectReason: rejectionDescription.trim()
//             };

//             // 🔥 SERVICE API
//             const data =
//                 await rejectPartnerApproval(
//                     partnerId,
//                     requestBody,
//                     token
//                 );

//             console.log("✅ Rejection API response:", data);

//             setShowRejectDropdown(false);

//             setRejectionDescription("");

//             if (data) {

//                 alert("Partner verification rejected successfully!");

//                 setPartnersData(prev =>
//                     prev.map(partner =>
//                         partner.id === partnerId ||
//                             partner.partnerId === partnerId
//                             ? {
//                                 ...partner,
//                                 verified: false,
//                                 rejectReason: rejectionDescription
//                             }
//                             : partner
//                     )
//                 );

//                 setPartnerDetails(prev => ({
//                     ...prev,
//                     verified: false,
//                     rejectReason: rejectionDescription
//                 }));

//                 setSelectedPartner(prev => ({
//                     ...prev,
//                     verified: false,
//                     rejectReason: rejectionDescription
//                 }));

//                 setIsApproved(false);

//                 setTimeout(() => {
//                     setRefreshKey(prev => prev + 1);
//                 }, 1000);

//             } else {

//                 throw new Error("Invalid response from server");
//             }

//         } catch (err) {

//             console.error("❌ Reject error:", err);

//             const errorMessage =
//                 err.response?.data?.message ||
//                 err.response?.data?.error ||
//                 err.message ||
//                 "Failed to reject partner";

//             alert(`Failed to reject: ${errorMessage}`);

//         } finally {

//             setIsRejecting(false);
//         }
//     };

//     const handleBackClick = () => setSelectedPartner(null);

//     const handleFileChange = (e, index) => {
//         const fileName = e.target.files[0]?.name || "";
//         const updated = [...rows];
//         updated[index].value = fileName;
//         setRows(updated);
//     };

//     // Clean Image Display Component with "-" for missing images
//     const ImageDisplay = ({ images, fieldName }) => {
//         if (!images || images.length === 0) {
//             return (
//                 <div className="text-center">
//                     <span style={{ fontSize: "18px", color: "#6c757d" }}>-</span>
//                 </div>
//             );
//         }

//         return (
//             <div className="d-flex justify-content-center gap-2 flex-wrap">
//                 {images.map((img, idx) => {
//                     const imageUrl = typeof img === 'string' ? img : img.url;
//                     const hasFailed = isImageFailed(fieldName, idx);

//                     if (hasFailed || !imageUrl) {
//                         return (
//                             <div key={idx} className="text-center">
//                                 <span style={{ fontSize: "18px", color: "#6c757d" }}>-</span>
//                             </div>
//                         );
//                     }

//                     return (
//                         <div key={idx} className="text-center position-relative">
//                             <img
//                                 src={imageUrl}
//                                 alt={`${fieldName}-${idx}`}
//                                 style={{
//                                     width: fieldName === "Profile Picture" ? "80px" : "60px",
//                                     height: fieldName === "Profile Picture" ? "80px" : "60px",
//                                     borderRadius: "6px",
//                                     objectFit: "cover",
//                                     border: "1px solid #dee2e6",
//                                 }}
//                                 onError={() => handleImageError(imageUrl, fieldName, idx)}
//                                 onLoad={() => handleImageLoad(imageUrl, fieldName, idx)}
//                             />
//                         </div>
//                     );
//                 })}
//             </div>
//         );
//     };

//     return (
//         <div className="container-fluid">
//             <div className="row">
//                 <div className="col-lg-12" style={{ marginTop: "10px" }}>
//                     <div className="client" style={{ overflowY: "auto", height: "450px" }}>
//                         {!selectedPartner ? (
//                             <>
//                                 {/* Filter Controls - Updated like Userdetails file */}
//                                 <div className="row g-2 mb-1 align-items-center me-0">
//                                     {/* Search Type Dropdown and Search Input - Side by Side */}
//                                     <div className="col-md-auto col-12">
//                                         <div className="d-flex align-items-center" style={{ gap: '10px' }}>

//                                             {/* Search Type Dropdown */}

//                                             <div style={{ minWidth: '150px' }}>
//                                                 <select
//                                                     className="form-select"
//                                                     value={searchType}
//                                                     onChange={(e) => setSearchType(e.target.value)}
//                                                     style={{ height: "40px" }}
//                                                 >
//                                                     {searchOptions.map(option => (
//                                                         <option key={option.value} value={option.value}>
//                                                             {option.label}
//                                                         </option>
//                                                     ))}
//                                                 </select>
//                                             </div>

//                                             {/* Search Input */}

//                                             <div style={{ minWidth: '200px' }}>
//                                                 <input
//                                                     type="text"
//                                                     className="form-control"
//                                                     placeholder={getPlaceholderText()}
//                                                     value={searchQuery}
//                                                     onChange={(e) => setSearchQuery(e.target.value)}
//                                                     style={{ height: "40px" }}
//                                                 />
//                                             </div>

//                                         </div>
//                                     </div>

//                                     {/* Status Filter */}
//                                     <div className="col-md-auto col-12">
//                                         <select
//                                             className="form-select"
//                                             value={statusFilter}
//                                             onChange={(e) => setStatusFilter(e.target.value)}
//                                             aria-label="Filter by status"
//                                             style={{ maxWidth: '150px', height: "40px" }}
//                                         >
//                                             <option value="">All Status</option>
//                                             <option value="verified">Verified</option>
//                                             <option value="not-verified">Not Verified</option>
//                                         </select>
//                                     </div>

//                                     {/* Vehicle Filter */}
//                                     <div className="col-md-auto col-12">
//                                         <select
//                                             className="form-select"
//                                             value={vehicleFilter}
//                                             onChange={(e) => setVehicleFilter(e.target.value)}
//                                             aria-label="Filter by vehicle"
//                                             style={{ maxWidth: '150px', height: "40px" }}
//                                         >
//                                             <option value="">All Vehicles</option>
//                                             {vehicleTypeOptions.map(option => (
//                                                 <option key={option} value={option}>{option}</option>
//                                             ))}
//                                         </select>
//                                     </div>



//                                     {/* Clear Filters Button */}
//                                     <div className="col-md-auto col-12">
//                                         <button
//                                             className="btn"
//                                             onClick={clearAllFilters}
//                                             style={{
//                                                 backgroundColor: '#6c757d',
//                                                 color: '#fff',
//                                                 height: "40px",
//                                                 padding: "0 15px"
//                                             }}
//                                         >
//                                             Clear Filters
//                                         </button>
//                                     </div>

//                                     {/* Refresh Data Button */}
//                                     <div className="col-md col-12">
//                                         <div className="d-flex justify-content-start justify-content-md-end">
//                                             <button
//                                                 className="btn"
//                                                 onClick={refreshAllData}
//                                                 style={{
//                                                     backgroundColor: 'rgb(230 109 51)',
//                                                     color: '#fff',
//                                                     height: "40px",
//                                                     padding: "0 20px"
//                                                 }}
//                                             >
//                                                 Refresh Data
//                                             </button>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="sed pe-3">
//                                     <table style={tableStyle} className="table table-striped">
//                                         <thead>
//                                             <tr>
//                                                 <th style={thStyle}>S.NO</th>
//                                                 <th style={thStyle}>Partner ID</th>
//                                                 <th style={thStyle}>Full Name</th>
//                                                 <th style={thStyle}>Email</th>
//                                                 <th style={thStyle}>Mobile</th>
//                                                 <th style={thStyle}>City</th>
//                                                 <th style={thStyle}>Vehicle Types</th>
//                                                 <th style={thStyle}>Status</th>
//                                                 <th style={thStyle}>Verified</th>
//                                                 <th style={thStyle}>Actions</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {filteredData.length ? (
//                                                 filteredData.map((partner, idx) => (
//                                                     <tr key={partner.id || idx}>
//                                                         <td style={thTdStyle}>{idx + 1}</td>
//                                                         <td style={thTdStyle}>{partner?.partnerId || "—"}</td>
//                                                         <td style={thTdStyle}>{partner?.fullName || "—"}</td>
//                                                         <td style={thTdStyle}>{partner?.maskedEmail || partner?.email || "—"}</td>
//                                                         <td style={thTdStyle}>{partner?.maskedPhoneNumber || partner?.phoneNumber || "—"}</td>
//                                                         <td style={thTdStyle}>{partner?.city || "—"}</td>
//                                                         <td style={thTdStyle}>
//                                                             {Array.isArray(partner?.vehicleTypes)
//                                                                 ? partner.vehicleTypes.join(", ")
//                                                                 : "—"}
//                                                         </td>
//                                                         <td style={thTdStyle}>
//                                                             <span className={`badge ${partner.online ? 'bg-primary' : 'bg-secondary'}`}>
//                                                                 {partner.online ? 'Online' : 'Offline'}
//                                                             </span>
//                                                         </td>
//                                                         <td style={thTdStyle}>
//                                                             <span className={`badge ${partner.verified ? 'bg-success' : 'bg-secondary'}`}>
//                                                                 {partner.verified ? 'Verified' : 'Pending'}
//                                                             </span>
//                                                         </td>
//                                                         <td style={thTdStyle}>
//                                                             <button
//                                                                 style={{ ...buttonStyle, color: "rgb(230 109 51)", fontWeight: "bold" }}
//                                                                 onClick={() => handleViewClick(partner)}
//                                                             >
//                                                                 View
//                                                             </button>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 <tr>
//                                                     <td style={thTdStyle} colSpan={10}>
//                                                         {partnersData.length === 0
//                                                             ? "Loading data or no partners found."
//                                                             : (searchQuery.trim() || statusFilter || vehicleFilter || cityFilter)
//                                                                 ? "No partners found with the specified filters."
//                                                                 : "No partners available."}
//                                                     </td>
//                                                 </tr>
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             </>
//                         ) : (
//                             <div className="mt-4 rounded-3 shadow-sm">
//                                 <div className="d-flex align-items-center mb-4">
//                                     <button
//                                         onClick={handleBackClick}
//                                         className="btn fw-bold px-4 py-2"
//                                         style={{ backgroundColor: "rgb(230 109 51)", color: "#fff" }}
//                                     >
//                                         Back to List
//                                     </button>

//                                 </div>

//                                 {loading && (
//                                     <div className="text-center my-4">
//                                         <span className="spinner-border text-primary" />
//                                     </div>
//                                 )}

//                                 {!loading && (
//                                     <>
//                                         <div className="register mt-4">
//                                             <div className="registertable bo2">
//                                                 <table className="table table-bordered table-striped align-middle mt-4 w-100">
//                                                     <thead>
//                                                         <tr>
//                                                             <th style={detailThStyle}>Field</th>
//                                                             <th style={detailThStyle}>Value</th>
//                                                             <th style={detailThStyle}>Image</th>
//                                                             <th style={detailThStyle}>Status</th>
//                                                         </tr>
//                                                     </thead>

//                                                     <tbody>
//                                                         {rows.map((r, i) => {
//                                                             const isEditing = r.isEditing || false;

//                                                             const handleInputChange = (field, value) => {
//                                                                 setRows((prevRows) =>
//                                                                     prevRows.map((row, idx) =>
//                                                                         idx === i
//                                                                             ? {
//                                                                                 ...row,
//                                                                                 value:
//                                                                                     typeof row.value === "object"
//                                                                                         ? { ...row.value, [field]: value }
//                                                                                         : value,
//                                                                             }
//                                                                             : row
//                                                                     )
//                                                                 );
//                                                             };

//                                                             // Handle array selection (multiple checkboxes)
//                                                             const handleArraySelection = (selectedValue, arrayField) => {
//                                                                 setRows((prevRows) =>
//                                                                     prevRows.map((row, idx) => {
//                                                                         if (idx === i) {
//                                                                             const currentValues = Array.isArray(row.value) ? row.value : [];
//                                                                             const isSelected = currentValues.includes(selectedValue);

//                                                                             if (isSelected) {
//                                                                                 // Remove if already selected
//                                                                                 return {
//                                                                                     ...row,
//                                                                                     value: currentValues.filter(v => v !== selectedValue)
//                                                                                 };
//                                                                             } else {
//                                                                                 // Add if not selected
//                                                                                 return {
//                                                                                     ...row,
//                                                                                     value: [...currentValues, selectedValue]
//                                                                                 };
//                                                                             }
//                                                                         }
//                                                                         return row;
//                                                                     })
//                                                                 );
//                                                             };

//                                                             const handleImageChange = (e) => {
//                                                                 const files = Array.from(e.target.files);
//                                                                 const newImages = files.map((file) => ({
//                                                                     url: URL.createObjectURL(file),
//                                                                     file
//                                                                 }));

//                                                                 setRows(prev =>
//                                                                     prev.map((row, idx) =>
//                                                                         idx === i
//                                                                             ? {
//                                                                                 ...row,
//                                                                                 images: [...(row.images || []), ...newImages]
//                                                                             }
//                                                                             : row
//                                                                     )
//                                                                 );
//                                                             };

//                                                             // Get appropriate options based on field
//                                                             const getOptions = () => {
//                                                                 switch (r.key) {
//                                                                     case "Vehicle Types": return vehicleTypeOptions;
//                                                                     case "Vehicles": return vehiclesOptions;
//                                                                     case "Petrolium Types": return petroliumTypeOptions;
//                                                                     default: return [];
//                                                                 }
//                                                             };

//                                                             return (
//                                                                 <tr key={r.key || i}>
//                                                                     <td className="fw-bold text-center align-middle">{r.key}</td>

//                                                                     <td className="text-start align-middle">
//                                                                         {r.key === "Vehicle Types" || r.key === "Vehicles" || r.key === "Petrolium Types" ? (
//                                                                             isEditing ? (
//                                                                                 <div className="d-flex flex-column gap-2">
//                                                                                     {getOptions().map((option) => {
//                                                                                         const currentValues = Array.isArray(r.value) ? r.value : [];
//                                                                                         const isSelected = currentValues.includes(option);

//                                                                                         return (
//                                                                                             <div key={option} className="form-check">
//                                                                                                 <input
//                                                                                                     className="form-check-input"
//                                                                                                     type="checkbox"
//                                                                                                     id={`${r.key}-${option}-${i}`}
//                                                                                                     checked={isSelected}
//                                                                                                     onChange={() => handleArraySelection(option, r.key)}
//                                                                                                 />
//                                                                                                 <label
//                                                                                                     className="form-check-label"
//                                                                                                     htmlFor={`${r.key}-${option}-${i}`}
//                                                                                                 >
//                                                                                                     {option}
//                                                                                                 </label>
//                                                                                             </div>
//                                                                                         );
//                                                                                     })}
//                                                                                 </div>
//                                                                             ) : (
//                                                                                 Array.isArray(r.value) && r.value.length > 0
//                                                                                     ? r.value.join(", ")
//                                                                                     : "N/A"
//                                                                             )
//                                                                         ) : r.key === "Bank Details" ? (
//                                                                             Object.entries(r.value || {}).map(([field, value]) => (
//                                                                                 <div key={field} className="mb-1">
//                                                                                     <strong>{field.replace(/([A-Z])/g, " $1")}:</strong>{" "}
//                                                                                     {isEditing ? (
//                                                                                         <input
//                                                                                             type="text"
//                                                                                             value={value || ""}
//                                                                                             onChange={(e) => handleInputChange(field, e.target.value)}
//                                                                                             className="form-control d-inline-block w-75 ms-2"
//                                                                                         />
//                                                                                     ) : (
//                                                                                         safeDisplay(value)
//                                                                                     )}
//                                                                                 </div>
//                                                                             ))
//                                                                         ) : r.key === "Current Address" || r.key === "Permanent Address" ? (
//                                                                             Object.entries(r.value || {}).map(([field, value]) => (
//                                                                                 <div key={field} className="mb-1">
//                                                                                     <strong>{field.charAt(0).toUpperCase() + field.slice(1)}:</strong>{" "}
//                                                                                     {isEditing ? (
//                                                                                         <input
//                                                                                             type="text"
//                                                                                             value={value || ""}
//                                                                                             onChange={(e) => handleInputChange(field, e.target.value)}
//                                                                                             className="form-control d-inline-block w-75 ms-2"
//                                                                                         />
//                                                                                     ) : (
//                                                                                         safeDisplay(value)
//                                                                                     )}
//                                                                                 </div>
//                                                                             ))
//                                                                         ) : r.key === "Profile Picture" ? (
//                                                                             "Profile Picture"
//                                                                         ) : r.key === "RC Number" || r.key === "Insurance Number" ? (
//                                                                             isEditing ? (
//                                                                                 <input
//                                                                                     type="text"
//                                                                                     value={r.value || ""}
//                                                                                     onChange={(e) => handleInputChange("value", e.target.value)}
//                                                                                     className="form-control d-inline-block w-75"
//                                                                                     placeholder="Enter comma-separated values"
//                                                                                 />
//                                                                             ) : (
//                                                                                 safeDisplay(r.value)
//                                                                             )
//                                                                         ) : (
//                                                                             isEditing ? (
//                                                                                 <input
//                                                                                     type="text"
//                                                                                     value={r.value || ""}
//                                                                                     onChange={(e) => handleInputChange("value", e.target.value)}
//                                                                                     className="form-control d-inline-block w-75"
//                                                                                 />
//                                                                             ) : (
//                                                                                 safeDisplay(r.value)
//                                                                             )
//                                                                         )}
//                                                                     </td>

//                                                                     <td className="text-center align-middle">
//                                                                         {isEditing ? (
//                                                                             <>
//                                                                                 <input
//                                                                                     type="file"
//                                                                                     multiple={r.key === "AADHAR Number" || r.key === "License Number" || r.key === "RC Number"}
//                                                                                     accept="image/*"
//                                                                                     onChange={handleImageChange}
//                                                                                     className="form-control mb-2"
//                                                                                 />
//                                                                                 <ImageDisplay images={r.images} fieldName={r.key} />
//                                                                             </>
//                                                                         ) : (
//                                                                             <ImageDisplay images={r.images} fieldName={r.key} />
//                                                                         )}
//                                                                     </td>

//                                                                     <td className="text-center align-middle">
//                                                                         {isEditing ? (
//                                                                             <>
//                                                                                 <button
//                                                                                     className="btn btn-sm btn-success me-2"
//                                                                                     style={{ minWidth: 80 }}
//                                                                                     onClick={() => handleSaveRow(i)}
//                                                                                 >
//                                                                                     Save
//                                                                                 </button>
//                                                                                 <button
//                                                                                     className="btn btn-sm btn-secondary"
//                                                                                     style={{ minWidth: 80 }}
//                                                                                     onClick={() =>
//                                                                                         setRows((prev) =>
//                                                                                             prev.map((row, idx) =>
//                                                                                                 idx === i ? { ...row, isEditing: false } : row
//                                                                                             )
//                                                                                         )
//                                                                                     }
//                                                                                 >
//                                                                                     Cancel
//                                                                                 </button>
//                                                                             </>
//                                                                         ) : (
//                                                                             <div style={{ display: "flex", gap: "10px" }}>
//                                                                                 <button
//                                                                                     className={`btn btn-sm ${isFieldVerified(r.key, r.value, partnerDetails)
//                                                                                         ? "btn-success"
//                                                                                         : "btn-warning"
//                                                                                         }`}
//                                                                                     style={{ minWidth: 80 }}
//                                                                                     onClick={() => handleVerifyy(i)}
//                                                                                     disabled={
//                                                                                         isFieldVerified(r.key, r.value, partnerDetails) ||
//                                                                                         isFieldRejected(r.key, partnerDetails)
//                                                                                     }
//                                                                                 >
//                                                                                     {isFieldVerified(r.key, r.value, partnerDetails) ? "Verified" : "Verify"}
//                                                                                 </button>

//                                                                                 <button
//                                                                                     className={`btn btn-sm ${isFieldRejected(r.key, partnerDetails) ? "btn-danger" : "btn-secondary"
//                                                                                         }`}
//                                                                                     style={{ minWidth: 80 }}
//                                                                                     onClick={() => handleReject(i)}
//                                                                                     disabled={
//                                                                                         isFieldRejected(r.key, partnerDetails) ||
//                                                                                         isFieldVerified(r.key, r.value, partnerDetails)
//                                                                                     }
//                                                                                 >
//                                                                                     {isFieldRejected(r.key, partnerDetails) ? "Rejected" : "Reject"}
//                                                                                 </button>

//                                                                                 <button
//                                                                                     className="btn btn-sm btn-primary"
//                                                                                     style={{ minWidth: 80 }}
//                                                                                     onClick={() =>
//                                                                                         setRows((prev) =>
//                                                                                             prev.map((row, idx) =>
//                                                                                                 idx === i ? { ...row, isEditing: true } : row
//                                                                                             )
//                                                                                         )
//                                                                                     }
//                                                                                 >
//                                                                                     Edit
//                                                                                 </button>
//                                                                             </div>
//                                                                         )}
//                                                                     </td>
//                                                                 </tr>
//                                                             );
//                                                         })}
//                                                     </tbody>
//                                                 </table>
//                                             </div>
//                                         </div>

//                                         {/* Approve and Reject Buttons at Bottom */}
//                                         <div className="d-flex justify-content-center gap-3 mt-4 mb-4 p-3 border-top position-relative">
//                                             <div className="d-flex gap-3 align-items-start position-relative">
//                                                 {/* Conditionally render Approve button or Approved status */}
//                                                 {partnerDetails?.verified === true || isApproved ? (
//                                                     <div className="d-flex align-items-center gap-3">
//                                                         <span className="badge bg-success p-2 fs-6">Approved</span>
//                                                     </div>
//                                                 ) : (
//                                                     <button
//                                                         className="btn btn-success px-4 py-2 fw-bold"
//                                                         style={{ minWidth: "120px" }}
//                                                         onClick={handleApproveAll}
//                                                         disabled={isApproving || isRejecting}
//                                                     >
//                                                         {isApproving ? (
//                                                             <>
//                                                                 <span className="spinner-border spinner-border-sm me-2"></span>
//                                                                 Approving...
//                                                             </>
//                                                         ) : (
//                                                             "Approve"
//                                                         )}
//                                                     </button>
//                                                 )}
//                                                 {/* Conditionally render Reject button or nothing */}
//                                                 {!(partnerDetails?.verified === true || isApproved) && (
//                                                     <div className="position-relative">
//                                                         {showRejectDropdown ? (
//                                                             <div className="card p-3 shadow-sm" style={{
//                                                                 width: "300px",
//                                                                 position: "absolute",
//                                                                 top: "100%",
//                                                                 left: "0",
//                                                                 marginTop: "0px",
//                                                                 zIndex: 1000
//                                                             }}>
//                                                                 <div className="mb-3">
//                                                                     <label className="form-label fw-bold">Rejection Reason</label>
//                                                                     <textarea
//                                                                         className="form-control"
//                                                                         rows="3"
//                                                                         placeholder="Enter rejection reason..."
//                                                                         value={rejectionDescription}
//                                                                         onChange={(e) => setRejectionDescription(e.target.value)}
//                                                                         disabled={isApproving || isRejecting}
//                                                                     />
//                                                                 </div>

//                                                                 <div className="d-flex gap-2">
//                                                                     <button
//                                                                         className="btn btn-danger flex-grow-1"
//                                                                         onClick={handleRejectAll}
//                                                                         disabled={!rejectionDescription.trim() || isApproving || isRejecting}
//                                                                     >
//                                                                         {isRejecting ? (
//                                                                             <>
//                                                                                 <span className="spinner-border spinner-border-sm me-2"></span>
//                                                                                 Rejecting...
//                                                                             </>
//                                                                         ) : (
//                                                                             "Confirm Reject"
//                                                                         )}
//                                                                     </button>
//                                                                     <button
//                                                                         className="btn btn-secondary"
//                                                                         onClick={() => {
//                                                                             setShowRejectDropdown(false);
//                                                                             setRejectionDescription("");
//                                                                         }}
//                                                                         disabled={isApproving || isRejecting}
//                                                                     >
//                                                                         Cancel
//                                                                     </button>
//                                                                 </div>
//                                                             </div>
//                                                         ) : (
//                                                             <button
//                                                                 className="btn btn-danger px-4 py-2 fw-bold"
//                                                                 style={{ minWidth: "120px" }}
//                                                                 onClick={() => setShowRejectDropdown(true)}
//                                                                 disabled={isApproving || isRejecting}
//                                                             >
//                                                                 {isRejecting ? (
//                                                                     <>
//                                                                         <span className="spinner-border spinner-border-sm me-2"></span>
//                                                                         Rejecting...
//                                                                     </>
//                                                                 ) : (
//                                                                     "Reject"
//                                                                 )}
//                                                             </button>
//                                                         )}
//                                                     </div>
//                                                 )}
//                                             </div>
//                                         </div>


//                                     </>
//                                 )}
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// const tableStyle = { width: "100%", borderCollapse: "collapse", marginTop: 5 };
// const thTdStyle = { border: "1px solid #ddd", textAlign: "center" };
// const thStyle = { ...thTdStyle, backgroundColor: "rgb(230 109 51)", color: "#fff", fontWeight: "bold", maxWidth: "70px" };
// const buttonStyle = { backgroundColor: "transparent", border: "none", cursor: "pointer" };

// const detailThStyle = {
//     ...thTdStyle,
//     backgroundColor: "rgb(230 109 51)",
//     color: "#fff",
//     fontWeight: 600,
//     padding: "0.75rem",
//     verticalAlign: "middle",
//     border: "1px solid #dee2e6",
//     textAlign: "center"
// };

// export default DeliveryPartnerManagement;




import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useLoader } from '../../../../context/LoaderProvider.jsx';
import {
    getPartnerDetails, getAllPartners, updatePartnerDetails, getAllDeliveryPartners,
    verifyPartnerField, rejectPartnerField,
    approvePartner, rejectPartnerApproval
} from "../../../Servicefile/clientManagementService.jsx";

// ============================================
// PREMIUM ICONS COMPONENT
// ============================================
const Icons = {
    Search: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
        </svg>
    ),
    Refresh: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M23 4v6h-6M1 20v-6h6"/>
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
        </svg>
    ),
    Clear: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
    ),
    Back: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="15 18 9 12 15 6"/>
        </svg>
    ),
    Edit: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
        </svg>
    ),
    Check: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
            <polyline points="20 6 9 17 4 12"/>
        </svg>
    ),
    X: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
    ),
    Save: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
            <polyline points="17 21 17 13 7 13 7 21"/>
            <polyline points="7 3 7 8 15 8"/>
        </svg>
    ),
    Upload: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="17 8 12 3 7 8"/>
            <line x1="12" y1="3" x2="12" y2="15"/>
        </svg>
    ),
    Approved: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#065f46" strokeWidth="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
            <polyline points="22 4 12 14.01 9 11.01"/>
        </svg>
    ),
    Online: () => (
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <path d="M12 6v6l4 2"/>
        </svg>
    ),
    Offline: () => (
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <line x1="8" y1="8" x2="16" y2="16"/>
            <line x1="16" y1="8" x2="8" y2="16"/>
        </svg>
    ),
    NoData: () => (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.5">
            <rect x="2" y="3" width="20" height="18" rx="2"/>
            <line x1="8" y1="21" x2="16" y2="21"/>
            <line x1="12" y1="17" x2="12" y2="21"/>
            <path d="M8 7h8M8 11h6M8 15h4"/>
        </svg>
    )
};

// ============================================
// PREMIUM STYLES
// ============================================
const styles = {
    container: {
        padding: '1px 5px',
        // background: '#f8f9fa',
        // borderRadius: '16px',
        // boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
        minHeight: '500px'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 0 16px 0',
        borderBottom: '2px solid #e9ecef',
        flexWrap: 'wrap',
        gap: '12px'
    },
    title: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#2d3748',
        letterSpacing: '-0.3px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    titleBadge: {
        background: 'rgb(230 109 51)',
        color: 'white',
        fontSize: '12px',
        fontWeight: '500',
        padding: '2px 12px',
        borderRadius: '12px',
        letterSpacing: '0.3px'
    },
    filtersContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '10px',
        padding: '12px 0',
        borderBottom: '1px solid #edf2f7',
        marginBottom: '16px'
    },
    searchGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flex: '1 1 auto',
        minWidth: '280px'
    },
    select: {
        padding: '8px 12px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        background: 'white',
        fontSize: '13px',
        fontWeight: '500',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.2s ease',
        height: '38px',
        minWidth: '140px',
        cursor: 'pointer'
    },
    input: {
        flex: '1',
        padding: '8px 14px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        fontSize: '13px',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.2s ease',
        height: '38px',
        background: 'white',
        minWidth: '180px'
    },
    button: {
        padding: '8px 16px',
        borderRadius: '8px',
        border: 'none',
        fontWeight: '500',
        fontSize: '13px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        height: '38px',
        whiteSpace: 'nowrap'
    },
    buttonPrimary: {
        background: 'rgb(230 109 51)',
        color: 'white'
    },
    buttonSecondary: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    buttonSuccess: {
        background: '#48bb78',
        color: 'white'
    },
    buttonDanger: {
        background: '#fc8181',
        color: 'white'
    },
    buttonWarning: {
        background: '#ecc94b',
        color: '#744210'
    },
    tableWrapper: {
        borderRadius: '10px',
        border: '1px solid #edf2f7',
        background: 'white',
        overflow: 'auto',
        maxHeight: '500px',
        position: 'relative'
    },
    table: {
        width: '100%',
        fontSize: '13px',
        borderCollapse: 'collapse',
        minWidth: '1100px'
    },
    thead: {
        position: 'sticky',
        top: 0,
        zIndex: 10
    },
    th: {
        padding: '10px 12px',
        textAlign: 'left',
        fontWeight: '600',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: 'white',
        background: '#e66d33',
        borderBottom: '2px solid #edf2f7',
        whiteSpace: 'nowrap'
    },
    td: {
        padding: '10px 12px',
        borderBottom: '1px solid #f1f5f9',
        color: '#2d3748',
        fontSize: '13px'
    },
    statusBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '3px 12px',
        borderRadius: '20px',
        fontSize: '11px',
        fontWeight: '500',
        letterSpacing: '0.3px'
    },
    statusActive: {
        background: '#c6f6d5',
        color: '#276749'
    },
    statusInactive: {
        background: '#fed7d7',
        color: '#9b2c2c'
    },
    statusOnline: {
        background: '#bee3f8',
        color: '#2a4365'
    },
    statusVerified: {
        background: '#c6f6d5',
        color: '#276749'
    },
    statusPending: {
        background: '#fefcbf',
        color: '#975a16'
    },
    detailHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '16px 0',
        borderBottom: '2px solid #e9ecef',
        marginBottom: '16px',
        flexWrap: 'wrap'
    },
    detailTitle: {
        fontSize: '18px',
        fontWeight: '600',
        color: '#2d3748',
        flex: 1
    },
    detailTableWrapper: {
        borderRadius: '10px',
        border: '1px solid #edf2f7',
        background: 'white',
        overflow: 'auto',
        maxHeight: '60vh'
    },
    detailTable: {
        width: '100%',
        fontSize: '13px',
        borderCollapse: 'collapse',
        minWidth: '700px'
    },
    detailTh: {
        padding: '10px 14px',
        textAlign: 'center',
        fontWeight: '600',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: 'white',
        background: 'rgb(230 109 51)',
        border: '1px solid #dee2e6'
    },
    detailTd: {
        padding: '10px 14px',
        border: '1px solid #dee2e6',
        verticalAlign: 'middle',
        fontSize: '13px'
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px',
        color: '#a0aec0'
    },
    emptyStateText: {
        marginTop: '16px',
        fontSize: '16px',
        fontWeight: '500',
        color: '#4a5568'
    },
    emptyStateSubtext: {
        fontSize: '13px',
        color: '#a0aec0',
        marginTop: '4px'
    },
    statsBar: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        padding: '8px 0 0 0',
        fontSize: '12px',
        color: '#718096',
        flexWrap: 'wrap'
    },
    statItem: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px'
    },
    statNumber: {
        fontWeight: '600',
        color: '#2d3748'
    },
    approvalContainer: {
        display: 'flex',
        justifyContent: 'center',
        gap: '12px',
        padding: '20px 0',
        marginTop: '16px',
        borderTop: '2px solid #e9ecef',
        flexWrap: 'wrap'
    },
    rejectCard: {
        padding: '16px',
        background: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
        width: '320px',
        position: 'absolute',
        top: 'calc(100% + 8px)',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1000,
        border: '1px solid #e2e8f0'
    },
    fieldLabel: {
        fontWeight: '600',
        color: '#2d3748',
        fontSize: '13px'
    },
    fieldValue: {
        color: '#4a5568',
        fontSize: '13px'
    }
};

// ============================================
// HELPER FUNCTIONS
// ============================================
const getDefaultDeliveryPartnerRows = () => [
    { key: "Full Name", value: "", isUpload: false },
    { key: "Phone Number", value: "", isUpload: false },
    { key: "Email", value: "", isUpload: false },
    { key: "Profile Picture", value: null, isUpload: false },
    { key: "AADHAR Number", value: "", isUpload: false },
    { key: "PAN Number", value: "", isUpload: false },
    { key: "License Number", value: "", isUpload: false },
    { key: "Vehicle Types", value: [], isUpload: false },
    { key: "Vehicles", value: [], isUpload: false },
    { key: "Petrolium Types", value: [], isUpload: false },
    { key: "RC Number", value: "", isUpload: false },
    { key: "Insurance Number", value: "", isUpload: false },
    {
        key: "Bank Details", value: {
            bankName: "",
            accountNumber: "",
            accountHolderName: "",
            ifscCode: "",
            branchName: "",
            upiId: ""
        }, isUpload: false
    },
    {
        key: "Current Address", value: {
            address: "",
            city: "",
            state: "",
            pinCode: "",
            country: "",
            houseNo: "",
            street: ""
        }, isUpload: false
    },
    {
        key: "Permanent Address", value: {
            permanentAddress: "",
            permanentCity: "",
            permanentState: "",
            permanentPinCode: "",
            permanentCountry: "",
            permanentHouseNo: "",
            permanentStreet: ""
        }, isUpload: false
    }
];

const vehicleTypeOptions = ["BIKE", "PASSENGER_AUTO", "CAR", "MINI_TRUCK", "TRUCK"];
const vehiclesOptions = ["TwoWheeler", "ThreeWheeler", "FourWheeler", "HeavyVehicle"];
const petroliumTypeOptions = ["PETROL", "DIESEL", "CNG", "ELECTRIC"];

const STATUS_FIELD_MAP = {
    "Full Name": "fullNameStatus",
    "Phone Number": "phoneNumberStatus",
    "Email": "emailStatus",
    "Profile Picture": "profilePictureStatus",
    "AADHAR Number": "aadharNumberStatus",
    "PAN Number": "panNumberStatus",
    "License Number": "licenseNumberStatus",
    "Vehicle Types": "vehicleTypesStatus",
    "Vehicles": "vehiclesStatus",
    "Petrolium Types": "petroliumTypesStatus",
    "RC Number": "rcNumberStatus",
    "Insurance Number": "insuranceNumberStatus",
    "Bank Details": "bankDetailsStatus",
    "Current Address": "addressStatus",
    "Permanent Address": "permanentAddressStatus"
};

const safeDisplay = (value) => {
    if (value === null || value === undefined) return "N/A";
    if (typeof value === 'string' && value.trim() === "") return "N/A";
    if (value === "N/A" || value === "Invalid Date") return "N/A";
    return value;
};

const hasValidData = (row, partnerDetails) => {
    if (!row || !partnerDetails) return false;
    const field = row.key;
    const value = row.value;

    if (typeof value === 'string') {
        return value && value !== "N/A" && value.trim() !== "";
    }
    if (Array.isArray(value)) {
        return value.length > 0 && value.some(item => item && item !== "N/A");
    }
    if (typeof value === 'object') {
        return Object.values(value).some(val => {
            if (val === null || val === undefined) return false;
            if (typeof val === 'string') return val.trim() !== "" && val !== "N/A";
            if (Array.isArray(val)) return val.length > 0;
            return true;
        });
    }
    return false;
};

const isFieldVerified = (rowKey, rowValue, partnerDetails) => {
    const normalisedKey = rowKey.trim().replace(/\.$/, "");
    const statusField = STATUS_FIELD_MAP[normalisedKey];
    if (!statusField || !partnerDetails) return false;
    if (partnerDetails[statusField] === true) return true;
    if ((partnerDetails[statusField] === null || partnerDetails[statusField] === undefined) &&
        hasValidData({ key: rowKey, value: rowValue }, partnerDetails)) {
        return true;
    }
    return false;
};

const isFieldRejected = (rowKey, partnerDetails) => {
    const normalisedKey = rowKey.trim().replace(/\.$/, "");
    const statusField = STATUS_FIELD_MAP[normalisedKey];
    if (!statusField || !partnerDetails) return false;
    return partnerDetails[statusField] === false;
};

// ============================================
// MAIN COMPONENT
// ============================================
const DeliveryPartnerManagement = () => {
    /* -------- list‑screen state -------- */
    const [partnersData, setPartnersData] = useState([]);
    const [statusFilter, setStatusFilter] = useState("");
    const [vehicleFilter, setVehicleFilter] = useState("");
    const [cityFilter, setCityFilter] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const { showLoader, hideLoader } = useLoader();

    const [searchType, setSearchType] = useState("partnerId");
    const [searchQuery, setSearchQuery] = useState("");

    /* -------- detail‑screen state -------- */
    const [selectedPartner, setSelectedPartner] = useState(null);
    const [partnerDetails, setPartnerDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState(getDefaultDeliveryPartnerRows());
    const [verifiedRows, setVerifiedRows] = useState([]);
    const [rejectedRows, setRejectedRows] = useState([]);
    const [isApproved, setIsApproved] = useState(false);
    const [imageLoadErrors, setImageLoadErrors] = useState(new Set());

    const fileInputRef = useRef(null);
    const [partnerData, setPartnerData] = useState({});
    const [rowId, setRowId] = useState(null);

    const [showRejectDropdown, setShowRejectDropdown] = useState(false);
    const [rejectionDescription, setRejectionDescription] = useState("");

    const [isApproving, setIsApproving] = useState(false);
    const [isRejecting, setIsRejecting] = useState(false);

    const [refreshKey, setRefreshKey] = useState(0);

    const getCurrentPartnerId = () => {
        return (
            selectedPartner?.id ||
            selectedPartner?.partnerId ||
            partnerDetails?.id ||
            null
        );
    };

    const partnerId = getCurrentPartnerId();

    const handleImageError = (imageUrl, fieldName, index) => {
        const errorKey = `${fieldName}-${index}`;
        setImageLoadErrors(prev => new Set([...prev, errorKey]));
    };

    const handleImageLoad = (imageUrl, fieldName, index) => {
        const errorKey = `${fieldName}-${index}`;
        setImageLoadErrors(prev => {
            const newSet = new Set(prev);
            newSet.delete(errorKey);
            return newSet;
        });
    };

    const isImageFailed = (fieldName, index) => {
        return imageLoadErrors.has(`${fieldName}-${index}`);
    };

    const fetchPartnerDetails = async (partnerId) => {
        if (!partnerId) return;
        setLoading(true);
        const token = localStorage.getItem("authToken");

        try {
            const data = await getPartnerDetails(partnerId, token);
            setPartnerDetails(data);
        } catch (err) {
            console.error("❌ get-partner-details error:", err);
            const listPartner = partnersData.find(
                p => p.id === partnerId || p.partnerId === partnerId
            );
            if (listPartner) {
                setPartnerDetails(listPartner);
            }
        } finally {
            setLoading(false);
        }
    };

    const refreshAllData = async () => {
        const token = localStorage.getItem("authToken");
        if (!token) {
            console.error("No auth token found");
            return;
        }
        showLoader();
        try {
            const data = await getAllPartners(token);
            setPartnersData(data);
            if (selectedPartner) {
                const currentPartnerId = selectedPartner?.id || selectedPartner?.partnerId;
                if (currentPartnerId) {
                    await fetchPartnerDetails(currentPartnerId);
                }
            }
        } catch (err) {
            console.error("Refresh data error:", err);
        } finally {
            hideLoader();
        }
    };

    const handleSaveRow = async (rowIndex) => {
        const token = localStorage.getItem("authToken") || localStorage.getItem("token");
        if (!token) {
            alert("No authentication token found");
            return;
        }

        try {
            const partnerId = getCurrentPartnerId();
            if (!partnerId) {
                console.error("Partner ID not found");
                return;
            }

            const row = rows[rowIndex];
            const formData = new FormData();
            const partnerData = {};

            const fieldMapping = {
                "Full Name": "fullName",
                "Phone Number": "phoneNumber",
                "Email": "email",
                "AADHAR Number": "aadharNumber",
                "PAN Number": "panNumber",
                "License Number": "licenseNumber",
                "Vehicle Types": "vehicleTypes",
                "Vehicles": "vehicles",
                "Petrolium Types": "petroliumTypes",
                "RC Number": "rcNumber",
                "Insurance Number": "insuranceNumber",
            };

            const backendFieldName = fieldMapping[row.key];

            if (backendFieldName && row.value && row.value !== "N/A") {
                if (Array.isArray(row.value)) {
                    partnerData[backendFieldName] = row.value;
                } else if (typeof row.value === "string") {
                    partnerData[backendFieldName] = row.value;
                }
            }

            if (row.key === "Current Address" && typeof row.value === "object") {
                Object.keys(row.value).forEach(key => {
                    if (row.value[key] !== "N/A") {
                        partnerData[key] = row.value[key];
                    }
                });
            }

            if (row.key === "Permanent Address" && typeof row.value === "object") {
                Object.keys(row.value).forEach(key => {
                    if (row.value[key] !== "N/A") {
                        partnerData[key] = row.value[key];
                    }
                });
            }

            if (row.key === "Bank Details" && typeof row.value === "object") {
                Object.keys(row.value).forEach(key => {
                    if (row.value[key] !== "N/A") {
                        partnerData[key] = row.value[key];
                    }
                });
            }

            formData.append(
                "partnerData",
                new Blob([JSON.stringify(partnerData)], { type: "application/json" })
            );

            if (row.images && row.images.length > 0) {
                row.images.forEach((img, idx) => {
                    if (img.file) {
                        const imageFieldName = getImageFieldName(row.key, idx);
                        formData.append(imageFieldName, img.file);
                    }
                });
            }

            await updatePartnerDetails(partnerId, formData, token);
            alert("Data updated successfully!");

            setRows(prev =>
                prev.map((r, idx) =>
                    idx === rowIndex ? { ...r, isEditing: false } : r
                )
            );

            fetchPartnerDetails(partnerId);

        } catch (err) {
            console.error("Error updating partner:", err);
            alert("Error updating data: " + (err.response?.data?.message || err.message));
        }
    };

    const getImageFieldName = (rowKey, imageIndex) => {
        const fieldMap = {
            "AADHAR Number": imageIndex === 0 ? "aadharCardFront" : "aadharCardBack",
            "PAN Number": "panCard",
            "License Number": imageIndex === 0 ? "licenseFront" : "licenseBack",
            "Profile Picture": "profilePicture",
            "RC Number": imageIndex === 0 ? "rcBookFront" : "rcBookBack",
        };
        return fieldMap[rowKey] || `image${imageIndex + 1}`;
    };

    const searchOptions = [
        { value: "partnerId", label: "Partner ID" },
        { value: "fullName", label: "Full Name" },
        { value: "email", label: "Email" },
        { value: "phoneNumber", label: "Mobile Number" },
        { value: "city", label: "City" }
    ];

    const getPlaceholderText = () => {
        switch (searchType) {
            case "partnerId": return "Search by Partner ID...";
            case "fullName": return "Search by Full Name...";
            case "email": return "Search by Email...";
            case "phoneNumber": return "Search by Mobile...";
            case "city": return "Search by City...";
            default: return "Search...";
        }
    };

    const clearAllFilters = () => {
        setSearchQuery("");
        setStatusFilter("");
        setVehicleFilter("");
        setCityFilter("");
    };

    useEffect(() => {
        const token = localStorage.getItem("authToken");
        if (!token) {
            console.error("No auth token found");
            return;
        }

        const fetchPartners = async () => {
            try {
                showLoader();
                const data = await getAllDeliveryPartners(token);
                setPartnersData(data);
            } catch (err) {
                console.error("Partners fetch error:", err);
            } finally {
                hideLoader();
            }
        };

        fetchPartners();
    }, [refreshKey]);

    useEffect(() => {
        let data = partnersData;

        if (statusFilter) {
            if (statusFilter === "verified") {
                data = data.filter((i) => i.verified === true);
            } else if (statusFilter === "not-verified") {
                data = data.filter((i) => i.verified === false);
            }
        }

        if (vehicleFilter) {
            data = data.filter((i) =>
                i.vehicleTypes?.includes(vehicleFilter) ||
                i.vehicles?.includes(vehicleFilter)
            );
        }

        if (cityFilter) {
            data = data.filter((i) => i.city === cityFilter);
        }

        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase().trim();
            data = data.filter(partner => {
                let fieldValue;

                if (searchType === "phoneNumber") {
                    fieldValue = partner.phoneNumber || partner.maskedPhoneNumber;
                } else if (searchType === "email") {
                    fieldValue = partner.email || partner.maskedEmail;
                } else {
                    fieldValue = partner[searchType];
                }

                if (!fieldValue) return false;

                if (searchType === "phoneNumber") {
                    const cleanPartnerMobile = fieldValue.toString().replace(/\D/g, '');
                    const cleanQuery = query.replace(/\D/g, '');
                    return fieldValue.toString().toLowerCase().includes(query) ||
                        cleanPartnerMobile.includes(cleanQuery);
                }

                return fieldValue.toString().toLowerCase().includes(query);
            });
        }

        setFilteredData(data);
    }, [partnersData, statusFilter, vehicleFilter, cityFilter, searchType, searchQuery]);

    useEffect(() => {
        if (!selectedPartner) {
            setRows(getDefaultDeliveryPartnerRows());
            setVerifiedRows([]);
            setRejectedRows([]);
            setIsApproved(false);
            setImageLoadErrors(new Set());
            return;
        }

        const dataSource = partnerDetails || selectedPartner;

        if (dataSource.verified === true) {
            setIsApproved(true);
        }

        const imageMap = {
            "AADHAR Number": [
                dataSource.aadharCardFront,
                dataSource.aadharCardBack
            ].filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
            "PAN Number": [dataSource.panCard]
                .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
            "License Number": [
                dataSource.licenseFront,
                dataSource.licenseBack
            ].filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
            "Profile Picture": [dataSource.profilePicture]
                .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
            "RC Number": [
                dataSource.rcBookFront,
                dataSource.rcBookBack
            ].filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
        };

        const newRows = [
            { key: "Full Name", value: dataSource.fullName || "N/A" },
            { key: "Phone Number", value: dataSource.phoneNumber || "N/A" },
            { key: "Email", value: dataSource.email || "N/A" },
            { key: "Profile Picture", value: "Profile Picture" },
            { key: "AADHAR Number", value: dataSource.aadharNumber || "N/A" },
            { key: "PAN Number", value: dataSource.panNumber || "N/A" },
            { key: "License Number", value: dataSource.licenseNumber || "N/A" },
            {
                key: "Vehicle Types",
                value: Array.isArray(dataSource.vehicleTypes)
                    ? dataSource.vehicleTypes
                    : (dataSource.vehicleTypes ? [dataSource.vehicleTypes] : [])
            },
            {
                key: "Vehicles",
                value: Array.isArray(dataSource.vehicles)
                    ? dataSource.vehicles
                    : (dataSource.vehicles ? [dataSource.vehicles] : [])
            },
            {
                key: "Petrolium Types",
                value: Array.isArray(dataSource.petroliumTypes)
                    ? dataSource.petroliumTypes
                    : (dataSource.petroliumTypes ? [dataSource.petroliumTypes] : [])
            },
            {
                key: "RC Number",
                value: Array.isArray(dataSource.rcNumber) && dataSource.rcNumber.length > 0
                    ? dataSource.rcNumber[0]
                    : dataSource.rcNumber || "N/A"
            },
            {
                key: "Insurance Number",
                value: Array.isArray(dataSource.insuranceNumber) && dataSource.insuranceNumber.length > 0
                    ? dataSource.insuranceNumber[0]
                    : dataSource.insuranceNumber || "N/A"
            },
            {
                key: "Bank Details",
                value: {
                    bankName: dataSource.bankName || "N/A",
                    accountNumber: dataSource.accountNumber || "N/A",
                    accountHolderName: dataSource.accountHolderName || "N/A",
                    ifscCode: dataSource.ifscCode || "N/A",
                    branchName: dataSource.branchName || "N/A",
                    upiId: dataSource.upiId || "N/A",
                },
            },
            {
                key: "Current Address",
                value: {
                    address: dataSource.address || "N/A",
                    city: dataSource.city || "N/A",
                    state: dataSource.state || "N/A",
                    pinCode: dataSource.pinCode || "N/A",
                    country: dataSource.country || "N/A",
                    houseNo: dataSource.houseNo || "N/A",
                    street: dataSource.street || "N/A",
                },
            },
            {
                key: "Permanent Address",
                value: {
                    permanentAddress: dataSource.permanentAddress || "N/A",
                    permanentCity: dataSource.permanentCity || "N/A",
                    permanentState: dataSource.permanentState || "N/A",
                    permanentPinCode: dataSource.permanentPinCode || "N/A",
                    permanentCountry: dataSource.permanentCountry || "N/A",
                    permanentHouseNo: dataSource.permanentHouseNo || "N/A",
                    permanentStreet: dataSource.permanentStreet || "N/A",
                },
            },
        ];

        const updatedRows = newRows.map((row) => ({
            ...row,
            images: imageMap[row.key] || [],
        }));

        setRows(updatedRows.map((r) => ({ ...r, isEditing: false })));
        setVerifiedRows([]);
        setRejectedRows([]);
        setImageLoadErrors(new Set());
    }, [selectedPartner, partnerDetails]);

    const handleViewClick = (partner) => {
        setSelectedPartner(partner);
        const partnerId = partner?.id || partner?.partnerId;
        fetchPartnerDetails(partnerId);
    };

    const handleVerifyy = async (i) => {
        const normalisedKey = rows[i].key.trim().replace(/\.$/, "");
        const statusField = STATUS_FIELD_MAP[normalisedKey];

        if (!statusField) {
            console.warn("No status mapping for:", rows[i].key);
            return;
        }

        const partnerId = getCurrentPartnerId();
        if (!partnerId) return alert("Partner ID is missing");

        try {
            const updateData = { [statusField]: true };
            const formData = new FormData();
            formData.append(
                "partnerData",
                new Blob([JSON.stringify(updateData)], { type: "application/json" })
            );

            await verifyPartnerField(partnerId, formData, localStorage.getItem("authToken"));
            await fetchPartnerDetails(partnerId);
            alert("Partner field verified successfully!");
        } catch (err) {
            console.error("❌ Verify error:", err);
            alert(`Failed to verify field: ${err.message}`);
        }
    };

    const handleReject = async (i) => {
        const normalisedKey = rows[i].key.trim().replace(/\.$/, "");
        const statusField = STATUS_FIELD_MAP[normalisedKey];

        if (!statusField) return;

        const partnerId = getCurrentPartnerId();
        if (!partnerId) return alert("Partner ID is missing");

        try {
            const updateData = { [statusField]: false };
            const formData = new FormData();
            formData.append(
                "partnerData",
                new Blob([JSON.stringify(updateData)], { type: "application/json" })
            );

            await rejectPartnerField(partnerId, formData, localStorage.getItem("authToken"));
            alert("Partner field rejected successfully!");
            fetchPartnerDetails(partnerId);
        } catch (err) {
            console.error("❌ Reject error:", err);
            alert(`Failed to reject field: ${err.message}`);
        }
    };

    const handleApproveAll = async () => {
        const partnerId = getCurrentPartnerId();
        if (!partnerId) {
            alert("Partner ID is missing");
            return;
        }

        setIsApproving(true);

        try {
            const token = localStorage.getItem("authToken");
            if (!token) {
                alert("Authorization token missing");
                return;
            }

            const payload = { rejectReason: "", verified: true };
            const data = await approvePartner(partnerId, payload, token);

            if (data) {
                alert("✅ Partner approved successfully!");
                setPartnerDetails(prev => ({ ...prev, ...data, verified: true }));
                setSelectedPartner(prev => ({ ...prev, ...data, verified: true }));
                setPartnersData(prev =>
                    prev.map(partner =>
                        partner.id === partnerId || partner.partnerId === partnerId
                            ? { ...partner, ...data, verified: true }
                            : partner
                    )
                );
                setIsApproved(true);
                setTimeout(() => setRefreshKey(prev => prev + 1), 1000);
            } else {
                alert("⚠️ Approval failed. Empty response from backend.");
            }
        } catch (err) {
            console.error("❌ Approve partner error:", err);
            const errorMessage = err.response?.data?.message || err.response?.data?.error || err.message;
            alert(`Failed to approve partner: ${errorMessage}`);
        } finally {
            setIsApproving(false);
        }
    };

    const handleRejectAll = async () => {
        if (!rejectionDescription.trim()) {
            alert("Please enter a rejection reason");
            return;
        }

        const partnerId = getCurrentPartnerId();
        if (!partnerId) return alert("Partner ID is missing");

        setIsRejecting(true);

        try {
            const token = localStorage.getItem("authToken");
            if (!token) return alert("Authorization token missing");

            const requestBody = {
                verified: false,
                rejectReason: rejectionDescription.trim()
            };

            const data = await rejectPartnerApproval(partnerId, requestBody, token);

            setShowRejectDropdown(false);
            setRejectionDescription("");

            if (data) {
                alert("Partner verification rejected successfully!");
                setPartnersData(prev =>
                    prev.map(partner =>
                        partner.id === partnerId || partner.partnerId === partnerId
                            ? { ...partner, verified: false, rejectReason: rejectionDescription }
                            : partner
                    )
                );
                setPartnerDetails(prev => ({ ...prev, verified: false, rejectReason: rejectionDescription }));
                setSelectedPartner(prev => ({ ...prev, verified: false, rejectReason: rejectionDescription }));
                setIsApproved(false);
                setTimeout(() => setRefreshKey(prev => prev + 1), 1000);
            } else {
                throw new Error("Invalid response from server");
            }
        } catch (err) {
            console.error("❌ Reject error:", err);
            const errorMessage = err.response?.data?.message || err.response?.data?.error || err.message || "Failed to reject partner";
            alert(`Failed to reject: ${errorMessage}`);
        } finally {
            setIsRejecting(false);
        }
    };

    const handleBackClick = () => setSelectedPartner(null);

    const handleFileChange = (e, index) => {
        const fileName = e.target.files[0]?.name || "";
        const updated = [...rows];
        updated[index].value = fileName;
        setRows(updated);
    };

    const ImageDisplay = ({ images, fieldName }) => {
        if (!images || images.length === 0) {
            return (
                <div className="text-center">
                    <span style={{ fontSize: "18px", color: "#6c757d" }}>—</span>
                </div>
            );
        }

        return (
            <div className="d-flex justify-content-center gap-2 flex-wrap">
                {images.map((img, idx) => {
                    const imageUrl = typeof img === 'string' ? img : img.url;
                    const hasFailed = isImageFailed(fieldName, idx);

                    if (hasFailed || !imageUrl) {
                        return (
                            <div key={idx} className="text-center">
                                <span style={{ fontSize: "18px", color: "#6c757d" }}>—</span>
                            </div>
                        );
                    }

                    return (
                        <div key={idx} className="text-center position-relative">
                            <img
                                src={imageUrl}
                                alt={`${fieldName}-${idx}`}
                                style={{
                                    width: fieldName === "Profile Picture" ? "80px" : "60px",
                                    height: fieldName === "Profile Picture" ? "80px" : "60px",
                                    borderRadius: "8px",
                                    objectFit: "cover",
                                    border: "2px solid #e2e8f0",
                                    transition: "transform 0.2s ease"
                                }}
                                onError={() => handleImageError(imageUrl, fieldName, idx)}
                                onLoad={() => handleImageLoad(imageUrl, fieldName, idx)}
                            />
                        </div>
                    );
                })}
            </div>
        );
    };

    // Calculate stats
    const totalPartners = partnersData.length;
    const verifiedCount = partnersData.filter(p => p.verified === true).length;
    const pendingCount = partnersData.filter(p => p.verified !== true).length;
    const onlineCount = partnersData.filter(p => p.online === true).length;

    return (
        <div style={styles.container}>
            {!selectedPartner ? (
                <>
                    {/* Header */}
                    

                    {/* Stats Bar */}
                    

                    {/* Filters */}
                    <div style={styles.filtersContainer}>
                        <div style={styles.searchGroup}>
                            <select
                                value={searchType}
                                onChange={(e) => setSearchType(e.target.value)}
                                style={styles.select}
                            >
                                {searchOptions.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>

                            <input
                                type="text"
                                placeholder={getPlaceholderText()}
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                style={{
                                    ...styles.input,
                                    borderColor: searchQuery ? 'rgb(230 109 51)' : '#e2e8f0'
                                }}
                            />
                        </div>

                        <select
                            value={statusFilter}
                            onChange={(e) => setStatusFilter(e.target.value)}
                            style={{ ...styles.select, minWidth: '110px' }}
                        >
                            <option value="">All Status</option>
                            <option value="verified">Verified</option>
                            <option value="not-verified">Pending</option>
                        </select>

                        <select
                            value={vehicleFilter}
                            onChange={(e) => setVehicleFilter(e.target.value)}
                            style={{ ...styles.select, minWidth: '110px' }}
                        >
                            <option value="">All Vehicles</option>
                            {vehicleTypeOptions.map(option => (
                                <option key={option} value={option}>{option}</option>
                            ))}
                        </select>

                        <button
                            onClick={clearAllFilters}
                            style={{ ...styles.button, ...styles.buttonSecondary }}
                        >
                            <Icons.Clear /> Clear
                        </button>
                    </div>

                    {/* Table */}
                    <div style={styles.tableWrapper}>
                        <table style={styles.table}>
                            <thead style={styles.thead}>
                                <tr>
                                    <th style={{ ...styles.th, width: '50px', textAlign: 'center' }}>#</th>
                                    <th style={styles.th}>Partner ID</th>
                                    <th style={styles.th}>Full Name</th>
                                    <th style={styles.th}>Email</th>
                                    <th style={styles.th}>Mobile</th>
                                    <th style={styles.th}>City</th>
                                    <th style={styles.th}>Vehicle</th>
                                    <th style={{ ...styles.th, textAlign: 'center' }}>Status</th>
                                    <th style={{ ...styles.th, textAlign: 'center' }}>Verified</th>
                                    <th style={{ ...styles.th, textAlign: 'center' }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.length ? (
                                    filteredData.map((partner, idx) => (
                                        <tr
                                            key={partner.id || idx}
                                            style={{
                                                backgroundColor: idx % 2 === 0 ? '#ffffff' : '#fafbfc',
                                                transition: 'background 0.15s ease'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f4ff'}
                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = idx % 2 === 0 ? '#ffffff' : '#fafbfc'}
                                        >
                                            <td style={{ ...styles.td, textAlign: 'center', color: '#a0aec0' }}>{idx + 1}</td>
                                            <td style={{ ...styles.td, fontFamily: 'monospace', fontSize: '12px' }}>
                                                {partner?.partnerId || "—"}
                                            </td>
                                            <td style={{ ...styles.td, fontWeight: '500' }}>
                                                {partner?.fullName || "—"}
                                            </td>
                                            <td style={{ ...styles.td, color: '#4a5568' }}>
                                                {partner?.maskedEmail || partner?.email || "—"}
                                            </td>
                                            <td style={styles.td}>
                                                {partner?.maskedPhoneNumber || partner?.phoneNumber || "—"}
                                            </td>
                                            <td style={styles.td}>
                                                {partner?.city || "—"}
                                            </td>
                                            <td style={styles.td}>
                                                <span style={{
                                                    fontSize: '11px',
                                                    background: '#edf2f7',
                                                    padding: '2px 8px',
                                                    borderRadius: '4px',
                                                    color: '#4a5568'
                                                }}>
                                                    {Array.isArray(partner?.vehicleTypes)
                                                        ? partner.vehicleTypes.join(", ")
                                                        : "—"}
                                                </span>
                                            </td>
                                            <td style={{ ...styles.td, textAlign: 'center' }}>
                                                <span style={{
                                                    ...styles.statusBadge,
                                                    ...(partner.online ? styles.statusOnline : styles.statusInactive)
                                                }}>
                                                    {partner.online ? 'Online' : 'Offline'}
                                                </span>
                                            </td>
                                            <td style={{ ...styles.td, textAlign: 'center' }}>
                                                <span style={{
                                                    ...styles.statusBadge,
                                                    ...(partner.verified ? styles.statusVerified : styles.statusPending)
                                                }}>
                                                    {partner.verified ? 'Verified' : 'Pending'}
                                                </span>
                                            </td>
                                            <td style={{ ...styles.td, textAlign: 'center' }}>
                                                <button
                                                    style={{
                                                        ...styles.button,
                                                        ...styles.buttonPrimary,
                                                        padding: '4px 14px',
                                                        height: '32px',
                                                        fontSize: '12px'
                                                    }}
                                                    onClick={() => handleViewClick(partner)}
                                                >
                                                    View
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="10" style={{ padding: 0 }}>
                                            <div style={styles.emptyState}>
                                                <Icons.NoData />
                                                <div style={styles.emptyStateText}>
                                                    {partnersData.length === 0 ? 'Loading partners...' : 'No partners found'}
                                                </div>
                                                <div style={styles.emptyStateSubtext}>
                                                    {partnersData.length === 0
                                                        ? 'Please wait while we fetch the data'
                                                        : (searchQuery.trim() || statusFilter || vehicleFilter || cityFilter)
                                                            ? 'Try adjusting your filters to see more results'
                                                            : 'No delivery partners are available'}
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </>
            ) : (
                /* ============ DETAIL VIEW ============ */
                <div>
                    {/* Detail Header */}
                    <div style={styles.detailHeader}>
                        <button
                            onClick={handleBackClick}
                            style={{ ...styles.button, ...styles.buttonPrimary }}
                        >
                            <Icons.Back /> Back
                        </button>
                        <div style={styles.detailTitle}>
                            Partner Details — <span style={{ color: 'rgb(230 109 51)' }}>
                                {selectedPartner?.fullName || 'N/A'}
                            </span>
                        </div>
                        {partnerDetails?.verified === true || isApproved ? (
                            <span style={{ ...styles.statusBadge, ...styles.statusVerified }}>
                                <Icons.Approved /> Approved
                            </span>
                        ) : (
                            <span style={{ ...styles.statusBadge, ...styles.statusPending }}>
                                <Icons.Offline /> Pending
                            </span>
                        )}
                    </div>

                    {loading && (
                        <div className="text-center my-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    )}

                    {!loading && (
                        <>
                            <div style={styles.detailTableWrapper}>
                                <table style={styles.detailTable}>
                                    <thead>
                                        <tr>
                                            <th style={styles.detailTh}>Field</th>
                                            <th style={styles.detailTh}>Value</th>
                                            <th style={styles.detailTh}>Image</th>
                                            <th style={styles.detailTh}>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rows.map((r, i) => {
                                            const isEditing = r.isEditing || false;

                                            const handleInputChange = (field, value) => {
                                                setRows((prevRows) =>
                                                    prevRows.map((row, idx) =>
                                                        idx === i
                                                            ? {
                                                                ...row,
                                                                value:
                                                                    typeof row.value === "object"
                                                                        ? { ...row.value, [field]: value }
                                                                        : value,
                                                            }
                                                            : row
                                                    )
                                                );
                                            };

                                            const handleArraySelection = (selectedValue) => {
                                                setRows((prevRows) =>
                                                    prevRows.map((row, idx) => {
                                                        if (idx === i) {
                                                            const currentValues = Array.isArray(row.value) ? row.value : [];
                                                            const isSelected = currentValues.includes(selectedValue);

                                                            if (isSelected) {
                                                                return {
                                                                    ...row,
                                                                    value: currentValues.filter(v => v !== selectedValue)
                                                                };
                                                            } else {
                                                                return {
                                                                    ...row,
                                                                    value: [...currentValues, selectedValue]
                                                                };
                                                            }
                                                        }
                                                        return row;
                                                    })
                                                );
                                            };

                                            const handleImageChange = (e) => {
                                                const files = Array.from(e.target.files);
                                                const newImages = files.map((file) => ({
                                                    url: URL.createObjectURL(file),
                                                    file
                                                }));

                                                setRows(prev =>
                                                    prev.map((row, idx) =>
                                                        idx === i
                                                            ? {
                                                                ...row,
                                                                images: [...(row.images || []), ...newImages]
                                                            }
                                                            : row
                                                    )
                                                );
                                            };

                                            const getOptions = () => {
                                                switch (r.key) {
                                                    case "Vehicle Types": return vehicleTypeOptions;
                                                    case "Vehicles": return vehiclesOptions;
                                                    case "Petrolium Types": return petroliumTypeOptions;
                                                    default: return [];
                                                }
                                            };

                                            return (
                                                <tr key={r.key || i}>
                                                    <td style={{ ...styles.detailTd, fontWeight: '600' }}>{r.key}</td>

                                                    <td style={styles.detailTd}>
                                                        {r.key === "Vehicle Types" || r.key === "Vehicles" || r.key === "Petrolium Types" ? (
                                                            isEditing ? (
                                                                <div className="d-flex flex-column gap-1">
                                                                    {getOptions().map((option) => {
                                                                        const currentValues = Array.isArray(r.value) ? r.value : [];
                                                                        const isSelected = currentValues.includes(option);

                                                                        return (
                                                                            <div key={option} className="form-check">
                                                                                <input
                                                                                    className="form-check-input"
                                                                                    type="checkbox"
                                                                                    id={`${r.key}-${option}-${i}`}
                                                                                    checked={isSelected}
                                                                                    onChange={() => handleArraySelection(option)}
                                                                                />
                                                                                <label
                                                                                    className="form-check-label"
                                                                                    htmlFor={`${r.key}-${option}-${i}`}
                                                                                >
                                                                                    {option}
                                                                                </label>
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            ) : (
                                                                Array.isArray(r.value) && r.value.length > 0
                                                                    ? r.value.join(", ")
                                                                    : "N/A"
                                                            )
                                                        ) : r.key === "Bank Details" ? (
                                                            Object.entries(r.value || {}).map(([field, value]) => (
                                                                <div key={field} className="mb-1">
                                                                    <strong>{field.replace(/([A-Z])/g, " $1")}:</strong>{" "}
                                                                    {isEditing ? (
                                                                        <input
                                                                            type="text"
                                                                            value={value || ""}
                                                                            onChange={(e) => handleInputChange(field, e.target.value)}
                                                                            className="form-control d-inline-block w-75"
                                                                        />
                                                                    ) : (
                                                                        safeDisplay(value)
                                                                    )}
                                                                </div>
                                                            ))
                                                        ) : r.key === "Current Address" || r.key === "Permanent Address" ? (
                                                            Object.entries(r.value || {}).map(([field, value]) => (
                                                                <div key={field} className="mb-1">
                                                                    <strong>{field.charAt(0).toUpperCase() + field.slice(1)}:</strong>{" "}
                                                                    {isEditing ? (
                                                                        <input
                                                                            type="text"
                                                                            value={value || ""}
                                                                            onChange={(e) => handleInputChange(field, e.target.value)}
                                                                            className="form-control d-inline-block w-75"
                                                                        />
                                                                    ) : (
                                                                        safeDisplay(value)
                                                                    )}
                                                                </div>
                                                            ))
                                                        ) : r.key === "Profile Picture" ? (
                                                            "Profile Picture"
                                                        ) : r.key === "RC Number" || r.key === "Insurance Number" ? (
                                                            isEditing ? (
                                                                <input
                                                                    type="text"
                                                                    value={r.value || ""}
                                                                    onChange={(e) => handleInputChange("value", e.target.value)}
                                                                    className="form-control"
                                                                />
                                                            ) : (
                                                                safeDisplay(r.value)
                                                            )
                                                        ) : (
                                                            isEditing ? (
                                                                <input
                                                                    type="text"
                                                                    value={r.value || ""}
                                                                    onChange={(e) => handleInputChange("value", e.target.value)}
                                                                    className="form-control"
                                                                />
                                                            ) : (
                                                                safeDisplay(r.value)
                                                            )
                                                        )}
                                                    </td>

                                                    <td style={{ ...styles.detailTd, textAlign: 'center' }}>
                                                        {isEditing ? (
                                                            <>
                                                                <input
                                                                    type="file"
                                                                    multiple={r.key === "AADHAR Number" || r.key === "License Number" || r.key === "RC Number"}
                                                                    accept="image/*"
                                                                    onChange={handleImageChange}
                                                                    className="form-control mb-2"
                                                                />
                                                                <ImageDisplay images={r.images} fieldName={r.key} />
                                                            </>
                                                        ) : (
                                                            <ImageDisplay images={r.images} fieldName={r.key} />
                                                        )}
                                                    </td>

                                                    <td style={{ ...styles.detailTd, textAlign: 'center' }}>
                                                        {isEditing ? (
                                                            <div className="d-flex flex-wrap gap-2 justify-content-center">
                                                                <button
                                                                    className="btn btn-sm btn-success"
                                                                    onClick={() => handleSaveRow(i)}
                                                                    style={{ minWidth: 70 }}
                                                                >
                                                                    <Icons.Save /> Save
                                                                </button>
                                                                <button
                                                                    className="btn btn-sm btn-secondary"
                                                                    onClick={() =>
                                                                        setRows((prev) =>
                                                                            prev.map((row, idx) =>
                                                                                idx === i ? { ...row, isEditing: false } : row
                                                                            )
                                                                        )
                                                                    }
                                                                    style={{ minWidth: 70 }}
                                                                >
                                                                    Cancel
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            <div className="d-flex flex-wrap gap-2 justify-content-center">
                                                                {isFieldVerified(r.key, r.value, partnerDetails) ? (
                                                                    <span style={{ ...styles.statusBadge, ...styles.statusVerified }}>
                                                                        <Icons.Check /> Verified
                                                                    </span>
                                                                ) : (
                                                                    <button
                                                                        className="btn btn-sm btn-warning"
                                                                        onClick={() => handleVerifyy(i)}
                                                                        disabled={
                                                                            isFieldVerified(r.key, r.value, partnerDetails) ||
                                                                            isFieldRejected(r.key, partnerDetails)
                                                                        }
                                                                        style={{ minWidth: 70 }}
                                                                    >
                                                                        Verify
                                                                    </button>
                                                                )}

                                                                {isFieldRejected(r.key, partnerDetails) ? (
                                                                    <span style={{ ...styles.statusBadge, ...styles.statusInactive }}>
                                                                        <Icons.X /> Rejected
                                                                    </span>
                                                                ) : (
                                                                    <button
                                                                        className="btn btn-sm btn-secondary"
                                                                        onClick={() => handleReject(i)}
                                                                        disabled={
                                                                            isFieldRejected(r.key, partnerDetails) ||
                                                                            isFieldVerified(r.key, r.value, partnerDetails)
                                                                        }
                                                                        style={{ minWidth: 70 }}
                                                                    >
                                                                        Reject
                                                                    </button>
                                                                )}

                                                                <button
                                                                    className="btn btn-sm btn-primary"
                                                                    onClick={() =>
                                                                        setRows((prev) =>
                                                                            prev.map((row, idx) =>
                                                                                idx === i ? { ...row, isEditing: true } : row
                                                                            )
                                                                        )
                                                                    }
                                                                    style={{ minWidth: 70 }}
                                                                >
                                                                    <Icons.Edit /> Edit
                                                                </button>
                                                            </div>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>

                            {/* Approval Section */}
                            <div style={styles.approvalContainer}>
                                {partnerDetails?.verified === true || isApproved ? (
                                    <span style={{ ...styles.statusBadge, ...styles.statusVerified, fontSize: '14px', padding: '6px 20px' }}>
                                        <Icons.Approved /> Approved ✓
                                    </span>
                                ) : (
                                    <>
                                        <button
                                            className="btn btn-success px-4 py-2 fw-bold"
                                            style={{ minWidth: "120px" }}
                                            onClick={handleApproveAll}
                                            disabled={isApproving || isRejecting}
                                        >
                                            {isApproving ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2"></span>
                                                    Approving...
                                                </>
                                            ) : (
                                                "Approve"
                                            )}
                                        </button>

                                        <div className="position-relative">
                                            {showRejectDropdown ? (
                                                <div style={styles.rejectCard}>
                                                    <div className="mb-3">
                                                        <label className="form-label fw-bold">Rejection Reason</label>
                                                        <textarea
                                                            className="form-control"
                                                            rows="3"
                                                            placeholder="Enter rejection reason..."
                                                            value={rejectionDescription}
                                                            onChange={(e) => setRejectionDescription(e.target.value)}
                                                            disabled={isApproving || isRejecting}
                                                        />
                                                    </div>
                                                    <div className="d-flex gap-2">
                                                        <button
                                                            className="btn btn-danger flex-grow-1"
                                                            onClick={handleRejectAll}
                                                            disabled={!rejectionDescription.trim() || isApproving || isRejecting}
                                                        >
                                                            {isRejecting ? (
                                                                <>
                                                                    <span className="spinner-border spinner-border-sm me-2"></span>
                                                                    Rejecting...
                                                                </>
                                                            ) : (
                                                                "Confirm Reject"
                                                            )}
                                                        </button>
                                                        <button
                                                            className="btn btn-secondary"
                                                            onClick={() => {
                                                                setShowRejectDropdown(false);
                                                                setRejectionDescription("");
                                                            }}
                                                            disabled={isApproving || isRejecting}
                                                        >
                                                            Cancel
                                                        </button>
                                                    </div>
                                                </div>
                                            ) : (
                                                <button
                                                    className="btn btn-danger px-4 py-2 fw-bold"
                                                    style={{ minWidth: "120px" }}
                                                    onClick={() => setShowRejectDropdown(true)}
                                                    disabled={isApproving || isRejecting}
                                                >
                                                    {isRejecting ? (
                                                        <>
                                                            <span className="spinner-border spinner-border-sm me-2"></span>
                                                            Rejecting...
                                                        </>
                                                    ) : (
                                                        "Reject"
                                                    )}
                                                </button>
                                            )}
                                        </div>
                                    </>
                                )}
                            </div>
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default DeliveryPartnerManagement;